import { render, staticRenderFns } from "./ContactDetailTest.vue?vue&type=template&id=589afc1c&scoped=true&"
import script from "./ContactDetailTest.vue?vue&type=script&lang=js&"
export * from "./ContactDetailTest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "589afc1c",
  null
  
)

export default component.exports